import React from 'react';
import { grey_1200 } from '@fiverr-private/sass/helpers/index';
import NavIcon from '../Navicon';

import styles from './BusinessSidebarTrigger.module.scss';

export const BusinessSidebarTrigger = (props) => (
    <NavIcon {...props} className={styles.sidebarTrigger} fill={grey_1200} />
);
